import {SiteApiDto} from "../../api/model/rest";
import SiteData from "./SiteData";

export default class Site {
	/**
	 * Site object.
	 * @param {string} id Identifier of the site.
	 * @param {SiteData} data Data of the site.
	 */
	constructor(public readonly id: string, public readonly data: SiteData) {}

	static fromJson(json: SiteApiDto): Site {
		return new Site(json.id, SiteData.fromJson(json));
	}
}